import { useMemo } from 'react'

import { useGetEarnings } from '../../../hooks/api/earnings/useGetEarnings'
import { useGetEarningsLetter } from '../../../hooks/api/earnings/useGetEarningsLetter'
import { useGetEarningsStats } from '../../../hooks/api/earnings/useGetEarningsStats'
import { useRequestDriverLetter } from '../../../hooks/api/earnings/useRequestDriverLetter'
import { SortParams } from '../../../types/interfaces'

type EarningsFilters = {
  limit: number
  page: number
  sort: SortParams
}

export const useEarnings = ({
  limit = 10,
  page = 1,
  sort = {},
}: EarningsFilters) => {
  const { data: earningsStats, isLoading: isLoadingStats } =
    useGetEarningsStats()

  const earningsFilters = useMemo(
    () => ({
      limit,
      page,
      sort,
    }),
    [limit, page, sort]
  )

  const { data: earnings, isLoading: isLoadingEarnings } =
    useGetEarnings(earningsFilters)

  const { data: earningLetter, isLoading: isLoadingEarningLetter } =
    useGetEarningsLetter()

  const {
    isPending: isRequestingDriverLetter,
    mutateAsync: requestDriverLetter,
  } = useRequestDriverLetter()

  return {
    earningLetter,
    earnings: earnings?.items || [],
    earningsPage: earnings?.current_page || 1,
    earningsPerPage: earnings?.limit || 10,
    earningsStats,
    isLoadingEarningLetter,
    isLoadingEarnings,
    isLoadingStats,
    isRequestingDriverLetter,
    requestDriverLetter,
    totalEarnings: earnings?.total_items || 0,
  }
}
